// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { FxBreadcrumbs } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import PageHeader from '../Headers/PageHeader';
// eslint-disable-next-line no-unused-vars
import UpdateContactParentForm from './UpdateContactParentForm';
// eslint-disable-next-line no-unused-vars
import UpdateContactResponse from './UpdateContactResponse';
import { combineBaseBreadcrumbWithFinal } from '../../../constants/breadcrumbs';

const UpdateContact = ({
  selectedContact,
  setStepNo,
  baseBreadcrumb,
  finalBreadcrumb,
  pageHeaderTxt,
  actionButtonLabelTxt,
  performAnotherActionButtonTxt,
  action,
  dialCodes,
}) => {
  const [updateContactStepNo, setUpdateContactStepNo] = useState(1);

  const [updatedContact, setUpdatedContact] = useState({});

  return (
    <>
      <FxBreadcrumbs breadcrumbItems={combineBaseBreadcrumbWithFinal(baseBreadcrumb, finalBreadcrumb)} />

      <PageHeader headerText={pageHeaderTxt} />

      {updateContactStepNo === 1 && (
        <UpdateContactParentForm
          selectedContact={selectedContact}
          setStepNo={setStepNo}
          setUpdateContactStepNo={setUpdateContactStepNo}
          setUpdatedContact={setUpdatedContact}
          actionButtonLabelTxt={actionButtonLabelTxt}
          dialCodes={dialCodes}
        />
      )}
      {updateContactStepNo === 2 && (
        <UpdateContactResponse
          updatedContact={updatedContact}
          performAnotherActionButtonTxt={performAnotherActionButtonTxt}
          action={action}
        />
      )}
    </>
  );
};

UpdateContact.propTypes = {
  selectedContact: PropTypes.shape({
  }).isRequired,
  setStepNo: PropTypes.func.isRequired,
  baseBreadcrumb: PropTypes.arrayOf().isRequired,
  finalBreadcrumb: PropTypes.shape({}).isRequired,
  pageHeaderTxt: PropTypes.string.isRequired,
  actionButtonLabelTxt: PropTypes.string.isRequired,
  performAnotherActionButtonTxt: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  dialCodes: PropTypes.arrayOf(),
};

export default UpdateContact;
